import appStrings from '@/app/utility/string.utility';
import UploadDocument from '@/app/components/onlineApproval/internalWorkFlow/history/uploadDocument';
import responseModal from '../../../../shared/responseModal';
import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'awardDetails',
  props: [
    'headerAllData',
    'rowData',
    'rfpHeaderId',
    'locationAllData',
    'negotiationHeaderId'
  ],
  components: {
    UploadDocument,
    responseModal
  },
  watch: {
    currentPageDelhiveryGstn: function() {
      this.getDelhiveryGstn();
    },
    perPageDelhiveryGstn: function() {
      this.currentPageDelhiveryGstn = 1;
      this.getDelhiveryGstn();
    }
  },
  data() {
    return {
      loader: false,
      legalEntity: null,
      userDepartment: null,
      startDate: null,
      endDate: null,
      bidType: null,
      paymentTerms: null,
      budget: null,
      retention: null,
      boqType: null,
      requestorName: null,
      requestorEmail: null,
      billingToSite: null,
      shipToSite: null,
      contactPersonName: null,
      contactPersonMobile: null,
      grnCreator: {
        name: null,
        email: null
      },
      ticketNumber: null,
      gstTaxRate: null,
      gstTaxType: null,
      clientName: null,
      clientApprovalMail: null,
      operatingUnit: {
        value: null,
        text: null,
        valueErp: null
      },
      area: null,
      contract: null,
      projectCarpetArea: null,
      officeMezzanineArea: null,
      sorterMezzanineArea: null,
      vendorName: null,
      vendorEmail: null,
      vendorCode: null,
      level: null,
      totalAmount: null,
      rfpNumber: null,
      taxedData: [],
      taxedFields: [
        {
          key: 'selectBox',
          label: 'Select',
          variant: 'info',
          stickyColumn: true
        },
        {
          key: 'po_num',
          label: 'PO Number'
        },
        {
          key: 'po_line_num',
          label: 'PO Line No.',
          class: 'col-fix-amount'
        },
        {
          key: 'boq_line_code',
          label: 'Oracle Line Description'
        },
        {
          key: 'tax_category',
          label: 'Tax Category'
        },
        // {
        //   key: 'tax_rate'
        // },
        {
          key: 'item_code'
        },
        {
          key: 'recoverable',
          class: 'col-fix-amount'
        },
        {
          key: 'amount',
          label: 'Amount(INR)',
          class: 'col-fix-amount text-right'
        },
        {
          key: 'tax_amount',
          label: 'Tax Amount(INR)',
          class: 'col-fix-amount text-right'
        },
        {
          key: 'total_amount',
          label: 'Total Amount(INR)',
          class: 'col-fix-amount text-right'
        },
        {
          key: 'status_code',
          class: 'col-fix-amount'
        },
        {
          key: 'status_message',
          class: 'no-wrap-text'
        }
      ],
      showValueSetModal: false,
      vsetCode: null,
      parent_value_set_id: null,
      selectedIndex: null,
      rfpVendorId: null,
      vendorGstn: null,
      delhiveryGstn: null,
      rfp_po_hdr_id: null,
      showHistory: false,
      historyType: null,
      selectedGridData: {
        le_id: '67',
        le_name: 'Delhivery Limited',
        nfa_cat_vset: null,
        nfa_cat: null,
        nfa_sub_cat_vset: null,
        nfa_sub_cat: null
      },
      showOpenResponseModal: false,
      vendorsBillingSiteData: [],
      vendorsBillingSiteFields: [
        {
          key: 'vendor_site_name'
        }
      ],
      vendorsBillingSite: null,
      vendorSiteNameSearch: null,
      responseModalName: null,
      delhiveryGstnData: [],
      delhiveryGstnFields: [
        {
          key: 'registration_number',
          label: 'Company GSTN'
        }
      ],
      currentPageDelhiveryGstn: 1,
      perPageDelhiveryGstn: 100,
      totalRowsDelhiveryGstn: null,
      taxCategoryData: [],
      taxCategoryFields: [
        {
          key: 'tax_category_name'
        }
      ],
      taxRateData: [],
      taxRateFields: [
        {
          key: 'tax_rate_percentage'
        }
      ],
      rfpItemCodeData: [],
      rfpItemCodeFields: [
        {
          key: 'item_code'
        }
      ],
      rfpOrgId: null,
      vendorSiteId: null,
      editMode: true,
      documentList: [],
      documentData: [],
      delhiverySiteData: [],
      delhiverySiteFields: [
        {
          key: 'location_code'
        }
      ],
      grnCreatorData: [],
      grnCreatorFields: [
        {
          key: 'employee_code',
          label: 'Emp. Code',
          class: 'col-fix-small text-left'
        },
        {
          key: 'user_name',
          label: 'Emp. Name',
          class: 'col-small-1 text-left'
        },
        {
          key: 'email_address',
          label: 'Emp. Email'
        }
      ],
      poPayload: {},
      organizationId: null,
      locationCode: null,
      locationId: null,
      formType: 'rfp',
      retentionPeriod: null,
      poStatus: null,
      status: null,
      selectAllCheckBox: false,
      selectedRow: [],
      taxCategory: {
        id: null,
        name: null,
        rate: null,
        state: null
      },
      statusMessage: null
    };
  },
  mounted() {
    this.getParentToChildData(this.headerAllData, this.rowData);
    this.getBoqLineCode();
  },
  methods: {
    getParentToChildData(data, rowdata) {
      this.legalEntity = data.le_name;
      this.userDepartment = data.user_department_meaning;
      this.rfpNumber = data.rfp_number;
      this.bidType =
        data.rfp_type === 'NRC_CE'
          ? 'Non-Rate Contract Closed Envelope'
          : 'Rate Contract Closed Envelope';
      this.paymentTerms = data.payment_terms;
      this.budget = data.budget;
      this.retention = data.retention;
      this.startDate = this.convertDateFormat(data.start_date);
      this.endDate = this.convertDateFormat(data.endDate);
      this.boqType = data.boqType;
      this.vendorName = rowdata.rfp_award_vendor_name;
      this.vendorEmail = rowdata.rfp_award_vendor_email;
      this.vendorCode = rowdata.vendor_code;
      this.level = rowdata.rank;
      this.totalAmount = rowdata.total;
      this.requestorName = data.creator_name;
      this.requestorEmail = data.creator_email;
      this.rfpVendorId = rowdata.rfp_vendor_id;
      let legalEntities = [
        {
          user_id: '100004',
          erp_org_id: '24276',
          org_short_name: 'DPL',
          org_id: '67',
          res_id: '46',
          value_code: 'Delhivery Limited',
          org_name: 'Delhivery Limited',
          value_set_dtl_id: '67'
        },
        {
          user_id: '100004',
          erp_org_id: '28275',
          org_short_name: 'DFS',
          org_id: '80',
          res_id: '46',
          value_code: 'Delhivery Freight Services Private Limited',
          org_name: 'Delhivery Freight Services Private Limited',
          value_set_dtl_id: '80'
        },
        {
          user_id: '100004',
          erp_org_id: '31276',
          org_short_name: 'DSPL',
          org_id: '81',
          res_id: '46',
          value_code: 'Delhivery Singapore Pte Ltd',
          org_name: 'Delhivery Singapore Pte Ltd',
          value_set_dtl_id: '81'
        },
        {
          user_id: '100004',
          erp_org_id: '23273',
          org_short_name: 'SSN',
          org_id: '87',
          res_id: '46',
          value_code: 'SSN Logistics Pvt. Ltd.',
          org_name: 'SSN Logistics Pvt. Ltd.',
          value_set_dtl_id: '87'
        },
        {
          user_id: '100004',
          erp_org_id: '27277',
          org_short_name: 'OSCPL',
          org_id: '91',
          res_id: '46',
          value_code: 'ORION SUPPLY CHAIN PRIVATE LIMITED',
          org_name: 'ORION SUPPLY CHAIN PRIVATE LIMITED',
          value_set_dtl_id: '91'
        },
        {
          user_id: '100004',
          erp_org_id: '25275',
          org_short_name: 'DUSA',
          org_id: '95',
          res_id: '46',
          value_code: 'Delhivery USA LLC',
          org_name: 'Delhivery USA LLC',
          value_set_dtl_id: '95'
        },
        {
          user_id: '100004',
          erp_org_id: '26279',
          org_short_name: 'DHK',
          org_id: '97',
          res_id: '46',
          value_code: 'Delhivery HK Pte Limited',
          org_name: 'Delhivery HK Pte Limited',
          value_set_dtl_id: '97'
        },
        {
          user_id: '100004',
          erp_org_id: '35274',
          org_short_name: '211',
          org_id: '13708',
          res_id: '46',
          value_code: 'SPOTON LOGISTICS PRIVATE LIMITED',
          org_name: 'SPOTON LOGISTICS PRIVATE LIMITED',
          value_set_dtl_id: '13708'
        }
      ];

      for (let i of legalEntities) {
        if (data.le_id == i.org_id) {
          this.rfpOrgId = i.erp_org_id;
        }
      }
      this.getPoHdrData();
    },
    convertDateFormat(inputDate) {
      const [datePart, timePart] = inputDate.split(' ');
      const [day, month, year] = datePart.split('-');
      const convertedDate = `${year}-${month}-${day}T${timePart}`;
      return convertedDate;
    },
    getBoqLineCode() {
      let payload = {
        _page: 0,
        _limit: 10000,
        rfp_header_id: this.rfpHeaderId,
        rfp_vendor_id: this.rfpVendorId,
        negotiation_hdr_id: this.negotiationHeaderId
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getBoqLineCode', payload)
        .then(response => {
          if (response.status === 200) {
            this.loader = false;
            let result = response.data.data.page;
            this.vendorGstn = result[0].rfp_award_vendor_gstn;
            this.taxedData = result;
            for (let i of this.taxedData) {
              i.tax_amount = 0;
              i.total_amount = 0;
            }
            let total = 0;
            let totalTax = 0;
            let totalAmount = 0;
            for (let i of this.taxedData) {
              total = total + i.amount;
              totalTax = i.tax_amount ? totalTax + +i.tax_amount : 0;
              totalAmount = i.total_amount ? totalAmount + +i.total_amount : 0;
            }
            for (let i = 0; i < result.length; i++) {
              this.taxedData[i].amount = result[i].amount.toFixed(2);
              this.taxedData[i].item_code = result[i].item_code;
            }
            this.taxedData.push({
              po_num: 'Total',
              boq_line_code: null,
              tax_category: null,
              item_code: null,
              amount: total.toFixed(2),
              tax_amount: totalTax.toFixed(2),
              total_amount: totalAmount.toFixed(2)
            });
            this.getDelhiveryGstn();
          } else {
            alert('Something went wrong');
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openValueSetModal(vsetCode, index) {
      this.selectedIndex = index;
      this.showValueSetModal = true;
      this.vsetCode = vsetCode;
      if (this.vsetCode === appStrings.VALUESETTYPE.OU_LIST) {
        this.parent_value_set_id = this.headerAllData.le_id;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    selectedvalueSet(item) {
      if (this.vsetCode === 'RFP_TAX_CATEGORY') {
        this.taxedData[this.selectedIndex].tax_category = item.tax_category;
      }
      if (this.vsetCode === 'TAX_VALUES') {
        this.taxedData[this.selectedIndex].tax_rate = item.value_code;
      }
      if (this.vsetCode === 'OU_LIST') {
        this.operatingUnit = {
          value: item.org_id,
          text: item.org_name,
          valueErp: item.erp_org_id
        };
      }
      setTimeout(() => {
        this.taxedData = JSON.parse(JSON.stringify(this.taxedData));
      }, 0);
      this.showValueSetModal = false;
    },
    copyTaxToAll() {
      let count = 0;
      let category = this.selectedRow[0].tax_category;
      for (let i of this.selectedRow) {
        if (category.includes('NON-RECOVERABLE') && i.recoverable === 'Y') {
          count = count + 1;
        } else if (
          !category.includes('NON-RECOVERABLE') &&
          i.recoverable === 'N'
        ) {
          count = count + 1;
        }
      }
      if (count > 0) {
        alert('Tax Type and Recoverable Flag mismatched');
      } else {
        let taxType = this.selectedRow[0].tax_category;
        let taxRate = this.selectedRow[0].taxRate;
        for (let i of this.taxedData) {
          if (i.selectBox) {
            i.tax_category = taxType;
            i.tax_rate = taxRate;
            i.tax_amount = ((taxRate * i.amount) / 100).toFixed(2);
            i.total_amount = +i.tax_amount + +i.amount;
            i.total_amount = i.total_amount.toFixed(2);
          }
        }
        this.taxedData = this.taxedData.map(data => {
          data.selectBox = false;
          return data;
        });
        this.selectedRow = [];
      }
      setTimeout(() => {
        this.taxedData = JSON.parse(JSON.stringify(this.taxedData));
      }, 0);
    },
    saveAwardeeDetailsData() {
      if (
        !this.operatingUnit.text ||
        !this.billingToSite ||
        !this.delhiveryGstn ||
        !this.shipToSite ||
        !this.contactPersonName ||
        !this.contactPersonMobile ||
        !this.grnCreator.email ||
        (this.operatingUnit.value === 343 && !this.clientName)
      ) {
        alert('Please enter mandatory fields');
      } else {
        let rfpPoDetails = [];
        for (let i = 0; i < this.taxedData.length - 1; i++) {
          rfpPoDetails.push({
            rfp_po_dtl_id: this.taxedData[i].rfp_po_dtl_id
              ? this.taxedData[i].rfp_po_dtl_id
              : 0,
            boq_line_code: this.taxedData[i].boq_line_code,
            tax_category: this.taxedData[i].tax_category,
            tax_rate: this.taxedData[i].tax_rate,
            amount: this.taxedData[i].amount,
            item_code: this.taxedData[i].item_code,
            status_code: null,
            status_message: null,
            tax_amount: this.taxedData[i].tax_amount,
            total_amount: this.taxedData[i].total_amount,
            recoverable: this.taxedData[i].recoverable
          });
        }
        let payload = {
          rfp_po_hdr_id: this.rfp_po_hdr_id ? this.rfp_po_hdr_id : 0,
          rfp_header_id: this.rfpHeaderId,
          ou_id: +this.operatingUnit.value,
          erp_org_id: +this.operatingUnit.valueErp,
          vendor_site_name: this.billingToSite,
          vendor_site_id: +this.vendorSiteId,
          third_party_gstn: this.vendorGstn,
          first_party_gstn: this.delhiveryGstn,
          first_party_site_person: this.contactPersonName,
          first_party_site_person_mob: +this.contactPersonMobile,
          grn_creator_name: this.grnCreator.name,
          grn_creator_email: this.grnCreator.email,
          fc_client_name: this.clientName,
          client_approval: 1,
          location_id: this.locationId,
          location_code: this.locationCode,
          organization_id: this.organizationId,
          ou_name: this.operatingUnit.text,
          requestor_name: this.requestorName,
          requestor_email_id: this.requestorEmail,
          retention_period: this.retentionPeriod,
          po_header_id: null,
          po_num: null,
          status_code: null,
          status_message: null,
          rfp_po_dtl: rfpPoDetails
        };
        this.loader = true;
        this.$store
          .dispatch('rfp/postPOData', payload)
          .then(response => {
            if (response.status === 200) {
              this.loader = false;
              this.rfp_po_hdr_id = response.data.data;
              this.getPoHdrData();
              this.selectAllCheckBox = false;
            } else {
              alert('Something went wrong');
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    getOpenKmAuthTokenUploadDocument() {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (this.openKmAuth) {
              this.showHideHistory(true, 'invoice');
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideHistory(flag, historyType) {
      this.showHistory = flag;
      this.historyType = historyType;
      this.getUploadedDocDtl();
    },
    getUploadedDocDtl() {
      const payload = {
        _page: 0,
        _limit: 100,
        menu_id: this.menuFromDashboard
          ? this.menuFromDashboard
          : this.$store.state.shared.menuId,
        sub_menu_id: 0,
        record_id: this.rfp_po_hdr_id
      };
      this.documentData = [];
      this.$store
        .dispatch('intWorkflow/getOpenKmDocDtl', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            if (response.data.data.page.length > 0) {
              const docList = response.data.data.page;
              this.documentList = response.data.data.page;
              this.documentData = docList.map(data => {
                data.file_size = this.formatBytes(data.file_size);
                return data;
              });
              // this.totalRows = response.data.data.total_elements;
            } else {
              this.$emit('closeModal');
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openCloseResponseModal(flag, name, index, item) {
      this.responseModalName = name;
      this.selectedIndex = index;
      if (name === 'vendorsBillingSite') {
        this.getVendorsBillingSiteData();
      } else if (name === 'delhiveryGstn') {
        this.getDelhiveryGstn();
      } else if (name === 'taxCategory') {
        this.getTaxCategoryData(item);
      } else if (name === 'rfpItemCode') {
        this.getRfpItemMasterData();
      } else if (name === 'taxRate') {
        if (!this.taxedData[this.selectedIndex].tax_type_id) {
          alert('Please select Tax Cartegory first');
        } else {
          this.getTaxRateData();
        }
      } else if (name === 'delhiverySite') {
        this.getDelhiverySiteData();
      } else if (name === 'grnCreator') {
        this.getGrnCreatorName();
      }
    },
    selectedVendorsBillingSite(flag, billingSite) {
      this.vendorSiteId = billingSite.vendor_site_id;
      this.showOpenResponseModal = flag;
      this.billingToSite = billingSite.vendor_site_name;
    },
    selectedDelhiveryGstn(flag, delhiveryGstn) {
      this.showOpenResponseModal = flag;
      this.delhiveryGstn = delhiveryGstn.registration_number;
      this.operatingUnit = {
        valueErp: delhiveryGstn.org_id,
        text: delhiveryGstn.ou_name
      };
      this.shipToSite = delhiveryGstn.location_code;
    },
    selectedTaxCategory(flag, taxCategory) {
      this.showOpenResponseModal = flag;
      this.taxedData[this.selectedIndex].tax_category =
        taxCategory.tax_category_name;
      this.taxedData[this.selectedIndex].tax_type_id = taxCategory.tax_type_id;
      this.taxedData[this.selectedIndex].taxRate = taxCategory.tax_rate;
      this.taxedData[this.selectedIndex].tax_state = taxCategory.tax_state;
      this.taxedData[this.selectedIndex].tax_amount =
        (+taxCategory.tax_rate * +this.taxedData[this.selectedIndex].amount) /
        100;
      this.taxedData[this.selectedIndex].tax_amount = this.taxedData[
        this.selectedIndex
      ].tax_amount.toFixed(2);
      this.taxedData[this.selectedIndex].total_amount =
        +this.taxedData[this.selectedIndex].tax_amount +
        +this.taxedData[this.selectedIndex].amount;
      this.taxedData[this.selectedIndex].total_amount = this.taxedData[
        this.selectedIndex
      ].total_amount.toFixed(2);
      // for (let i of this.taxedData) {
      //   this.taxedData[this.taxedData.length - 1].tax_amount =
      //     +this.taxedData[this.taxedData.length - 1].tax_amount + +i.tax_amount;
      // }
      if (this.selectedRow[this.selectedIndex].selectBox) {
        this.selectedRow[0] = this.taxedData[this.selectedIndex];
      }
      // this.taxedData[this.taxedData.length - 1].tax_amount = 0;
      // this.taxedData[this.taxedData.length - 1].total_amount = 0;
      // setTimeout(() => {
      //   let totalTax = 0;
      //   let totalAmount = 0;
      //   for (let i of this.taxedData) {
      //     totalTax = totalTax + +i.tax_amount;
      //     totalAmount = totalAmount + +i.total_amount;
      //   }
      //   this.taxedData[this.taxedData.length - 1].tax_amount = totalTax.toFixed(
      //     2
      //   );
      //   this.taxedData[
      //     this.taxedData.length - 1
      //   ].total_amount = totalAmount.toFixed(2);
      // }, 500);

      setTimeout(() => {
        this.taxedData = JSON.parse(JSON.stringify(this.taxedData));
      }, 0);
    },
    selectedTaxRate(flag, taxRate) {
      this.showOpenResponseModal = flag;
      this.taxedData[this.selectedIndex].tax_rate = taxRate.tax_rate_percentage;
      setTimeout(() => {
        this.taxedData = JSON.parse(JSON.stringify(this.taxedData));
      }, 0);
    },
    selectedRfpItemCode(flag, itemCode) {
      this.showOpenResponseModal = flag;
      this.taxedData[this.selectedIndex].item_code = itemCode.item_code;
      setTimeout(() => {
        this.taxedData = JSON.parse(JSON.stringify(this.taxedData));
      }, 0);
    },
    selectedGrnCreator(flag, grnCreator) {
      this.showOpenResponseModal = flag;
      this.grnCreator = {
        email: grnCreator.email_address,
        name: grnCreator.user_name
      };
    },
    selectedDelhiverySite(flag, delhiverySite) {
      this.shipToSite = delhiverySite.location_code;
      this.showOpenResponseModal = flag;
    },
    getVendorsBillingSiteData() {
      const payload = {
        _page: 0,
        _limit: 1000,
        vendor_site_name: this.vendorSiteNameSearch,
        vendor_id: this.vendorCode,
        org_id: +this.operatingUnit.valueErp,
        invoice_date: commonHelper.formattedDate(this.startDate),
        registration_number: this.vendorGstn
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getVendorSiteDetails', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data.page;
            this.vendorsBillingSiteData = result;
            this.showOpenResponseModal = true;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getDelhiveryGstn() {
      const payload = {
        state_code: this.locationAllData[0].state_code,
        cost_center: this.locationAllData[0].cost_centre
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getDelhiveryGstn', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data;
            this.delhiveryGstn = result[0].registration_number;
            this.shipToSite = result[0].location_code;
            this.operatingUnit = {
              valueErp: result[0].org_id,
              text: result[0].ou_name
            };
            this.locationId = result[0].location_id;
            this.locationCode = result[0].location_code;
            this.organizationId = result[0].organization_id;
            this.getRfpItemFlag(this.taxedData);
            // this.totalRowsDelhiveryGstn =
            //   response.data.data.data.total_elements;
            // this.delhiveryGstnData = result;
            // this.showOpenResponseModal = true;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getTaxCategoryData(item) {
      if (!this.delhiveryGstn) {
        alert('Please select Delhivery GSTN first');
      } else {
        let vendor = this.vendorGstn.slice(0, 2);
        let delhivery = this.delhiveryGstn.slice(0, 2);
        this.responseModalPayload = {
          vendor: vendor,
          delhivery: delhivery,
          org_id: this.operatingUnit.valueErp
        };
        const payload = {
          _page: 0,
          _limit: 1000,
          state_match_flag: vendor === delhivery ? 1 : 0,
          org_id: this.operatingUnit.valueErp,
          tax_recoverable: item.recoverable
        };
        this.loader = true;
        this.$store
          .dispatch('rfp/getTaxCategoryData', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              let result = response.data.data.data.page;
              this.taxCategoryData = result;
              this.showOpenResponseModal = true;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    getTaxRateData() {
      const payload = {
        _page: 0,
        _limit: 1000,
        tax_type_id: this.taxedData[this.selectedIndex].tax_type_id,
        legal_entity: this.rfpOrgId
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getTaxRateData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data.data.page;
            this.taxRateData = result;
            this.showOpenResponseModal = true;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getRfpItemMasterData() {
      const payload = {
        _page: 0,
        _limit: 1000,
        item_code: null,
        item_description: this.taxedData[this.selectedIndex].boq_line_code,
        rfp_boq_item_type: this.boqType
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getRfpItemMasterData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data.page;
            this.rfpItemCodeData = result;
            this.showOpenResponseModal = true;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getPoHdrData() {
      const payload = {
        rfp_hdr_id: this.rfpHeaderId
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getPOData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data[0];
            this.status = result.status_code;
            if (this.status === 'E') {
              this.status = 'ERROR';
            }
            this.billingToSite = result.vendor_site_name;
            this.vendorSiteId = result.vendor_site_id;
            this.statusMessage = result.status_message;
            this.delhiveryGstn = result.first_party_gstn;
            this.shipToSite = result.first_party_site_person;
            this.contactPersonName = result.first_party_site_person;
            this.contactPersonMobile = result.first_party_site_person_mob;
            this.grnCreator = {
              name: result.grn_creator_name,
              email: result.grn_creator_email
            };
            this.clientName = result.fc_client_name;
            this.rfp_po_hdr_id = result.rfp_po_hdr_id;
            this.getUploadedDocDtl();
            this.operatingUnit = {
              value: result.ou_id,
              text: result.ou_name,
              valueErp: result.erp_org_id
            };
            this.locationId = result.location_id;
            this.organizationId = result.organization_id;
            this.requestorName = result.requestor_name;
            this.requestorEmail = result.requestor_email_id;
            this.retentionPeriod = result.retention_period;
            this.poStatus = result.status_code;
            this.editMode = false;
            setTimeout(() => {
               this.getPoDtlData();
              }, 1000);
           }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    checkMobileNumber() {
      if (this.contactPersonMobile.length !== 10) {
        alert('Please enter valid Mobile Number');
        this.contactPersonMobile = null;
      }
    },
    getPoDtlData() {
      const payload = {
        _page: 0,
        _limit: 10000,
        rfp_po_hdr_id: this.rfp_po_hdr_id
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getPODtlData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data.page;
            this.taxedData = result;
            let total = 0;
            let totalTax = 0;
            let totalAmount = 0;
            for (let i of this.taxedData) {
              i.status_code = i.status_code === 'E' ? 'ERROR' : i.status_code;
              total = total + i.amount;
              totalTax = +totalTax + +i.tax_amount;
              totalAmount = totalAmount + +i.total_amount;
            }
            for (let i = 0; i < result.length; i++) {
              this.taxedData[i].amount = result[i].amount.toFixed(2);
              this.taxedData[i].tax_amount = result[i].tax_amount.toFixed(2);
              this.taxedData[i].total_amount = result[i].total_amount.toFixed(
                2
              );
            }
            this.taxedData.push({
              po_num: 'Total',
              boq_line_code: null,
              tax_category: null,
              item_code: null,
              amount: total.toFixed(2),
              tax_amount: totalTax.toFixed(2),
              total_amount: totalAmount.toFixed(2)
            });
            this.editMode = false;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    alterEditMode() {
      this.editMode = !this.editMode;
    },
    getDelhiverySiteData() {
      const payload = {
        _page: 0,
        _limit: 100,
        gst_number: this.delhiveryGstn
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getRfpDelhiverySite', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data.data.page;
            this.delhiverySiteData = result;
            this.showOpenResponseModal = true;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getGrnCreatorName() {
      const payload = {
        _page: 0,
        _limit: 1000,
        employee_code: null,
        user_name: null,
        user_email: null
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getGrnCreatorName', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data.data.page;
            this.grnCreatorData = result;
            this.showOpenResponseModal = true;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getPoPayload() {
      const payload = {
        rfp_header_id: this.rfpHeaderId
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getPoPayload', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data;
            this.poPayload = result;
            this.postToOracle();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    postToOracle() {
      const payload = this.poPayload;
      this.loader = true;
      this.$store
        .dispatch('rfp/postToOracle', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let message = response.data.data.data;
            this.makeToast(message, 'success');
            this.updatePo();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    makeToast(content, variant) {
      this.$bvToast.toast(content, {
        title: 'Alert',
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-center',
        appendToast: true,
        toastClass: 'custom-toast',
        autoHideDelay: 2000
      });
    },
    updatePo() {
      const payload = {
        rfp_po_hdr_id: this.rfp_po_hdr_id
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/updatePostToOracle', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let message = response.data.data.data;
            this.getPoHdrData();
            this.makeToast(message, 'success');
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    selectBoxChecked(flag, index, item, itemCode) {
      this.taxedData[index].selectBox = flag;
      if (flag === true) {
        this.selectedRow.push(item);
        if (this.selectedRow.length === this.taxedData.length - 1) {
          this.selectAllCheckBox = true;
        }
      } else {
        this.selectedRow = this.selectedRow.filter(
          el => el.item_code !== itemCode
        );
        this.selectAllCheckBox = false;
      }
    },
    selectAllBoxChecked(flag) {
      this.selectedRow = [];
      if (flag) {
        this.taxedData = this.taxedData.map((data, index) => {
          if (index !== this.taxedData.length - 1) {
            data.selectBox = this.selectAllCheckBox;
            if (this.selectAllCheckBox) {
              this.selectBoxChecked(data.selectBox, index);
            }
          }
          return data;
        });
        this.selectedRow = this.taxedData;
      } else {
        this.taxedData = this.taxedData.map((data, index) => {
          data.selectBox = this.selectAllCheckBox;
          if (this.selectAllCheckBox) {
            this.selectBoxChecked(data.selectBox, index);
          }
          return data;
        });
        this.selectedRow = [];
      }
    },
    // selectedTaxCategory(flag, taxCategory) {
    //   this.taxCategory = {
    //     id: taxCategory.tax_category_id,
    //     name: taxCategory.tax_category_name,
    //     rate: taxCategory.tax_rate,
    //     state: taxCategory.tax_state
    //   };
    //   this.showOpenResponseModal = flag;
    // },
    getRfpItemFlag(data) {
      let itemCodeList = [];
      for (let i of data) {
        itemCodeList.push({
          item_code: i.item_code
        });
      }
      const payload = {
        organization_id: this.organizationId,
        item_code_list: itemCodeList
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/postRfpItemFlag', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data.data;
            for (let i = 0; i < this.taxedData.length - 1; i++) {
              for (let j = 0; j < result.length; j++) {
                if (this.taxedData[i].item_code === result[j].item_code) {
                  this.taxedData[i].recoverable = result[j].recoverable_flag;
                }
              }
            }
            setTimeout(() => {
              this.taxedData = JSON.parse(JSON.stringify(this.taxedData));
            }, 0);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getTotal() {
      this.taxedData[this.taxedData.length - 1].tax_amount = 0;
      this.taxedData[this.taxedData.length - 1].total_amount = 0;
      for (let [index, i] of this.taxedData.entries()) {
        if (index === this.taxedData.length - 1) break;
        else {
          this.taxedData[this.taxedData.length - 1].tax_amount =
            +this.taxedData[this.taxedData.length - 1].tax_amount +
            +i.tax_amount;
          this.taxedData[this.taxedData.length - 1].total_amount =
            +this.taxedData[this.taxedData.length - 1].total_amount +
            +i.total_amount;
        }
      }
      this.taxedData[this.taxedData.length - 1].tax_amount = this.taxedData[
        this.taxedData.length - 1
      ].tax_amount.toFixed(2);
      this.taxedData[this.taxedData.length - 1].total_amount = this.taxedData[
        this.taxedData.length - 1
      ].total_amount.toFixed(2);
    }
  }
};
